<template>
  <div id="login">
    <el-container>
      <el-header><i class="fas fa-sign-in-alt"></i> ログイン</el-header>
      <el-main>
        <el-form ref="refFrmLogin" :model="frmLogin" :rules="rules" label-width="100px">
          <el-form-item label="ユーザID" prop="user_id">
            <el-input placeholder="user@example.com" v-model="frmLogin.user_id"></el-input>
          </el-form-item>
          <el-form-item label="パスワード" prop="password">
            <el-input placeholder="パスワードを入力してください。" v-model="frmLogin.password" show-password></el-input>
          </el-form-item>
          <p class="err_msg" v-if="message">{{ message }}</p>
          <el-form-item>
            <el-button type="primary" @click="login">Log in</el-button>
            <el-button type="default" @click="back">戻る</el-button>
          </el-form-item>
          <el-form-item>
            <router-link to="/regist">アカウント作成（新規登録）</router-link><br>
            <router-link to="/pwresetreq">パスワードを忘れた（再設定）</router-link>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { clsUser } from '@/types/clsUser';

export default defineComponent({
  setup(_, context) {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmLogin: any = ref(null)
    const message = ref('')
    const frmLogin = reactive({
      user_id: '',
      password: ''
    })
    const rules = {
      user_id: [
        { required: true, message: 'ユーザIDを入力してください。', trigger: 'blur' },
      ],
      password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
      ]
    }
    const loginUser = new clsUser()
    const beforePage = history.state.back
    const login = () => {
      const api_path = internalInstance?.appContext.config.globalProperties.api_path
      refFrmLogin.value.validate((valid: boolean) => {
        if(valid) {
          fetch(api_path + 'ajax/login.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmLogin)
          })
          .then(response => response.json())
          .then(json => {
            if(json['result'] == 'failure') {
              throw new Error(json.error)
            }
            //console.log(json)
            message.value = ""
            loginUser.login = true
            loginUser.name = json['user_name']
            loginUser.email = json['address']
            loginUser.csrf = json['csrf']
            loginUser.admin_flg = json['admin_flg'] == '1'
            loginUser.validmail = json['validmail'] == '1'
            context.emit('login', loginUser)
            if(['/','/map'].includes(beforePage)) {
              router.push({ path: beforePage })  
            }else {
              router.push({ path: '/' })
            }
          })
          .catch(error => {
            console.error(error)
            message.value = error.message
          })
        }else {
          console.log('Did not submit.')
        }
      })
    }
    const back = () => {
      if(['/','/map'].includes(beforePage)) {
        router.push({ path: beforePage })  
      }else {
        router.push({ path: '/' })
      }
    }

    return {
      refFrmLogin,
      frmLogin,
      rules,
      back,
      login,
      message
    }
  }
})
</script>

<style>
#login {
  height: calc(100% - 69px);
  background-color: #ecf0f5;
  position: relative;
  overflow: auto;
}
#login .el-form {
  text-align: left;
}
#login .el-header {
  padding-top: 30px;
  color: #6f6f6f;
  font-size: larger;
  text-align: center;
}
#login .el-container {
  width: 400px;
  margin: 0 auto;
}
.err_msg {
  text-align: center;
  color: red;
}
</style>